import { Component } from '@angular/core';
import { formatTime } from 'app/core/shared/helper/time.helper';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';
import { combineDateTime, handleFormatDate } from 'app/core/shared/helper/date.helper';
import { AprService } from 'app/modules/annulus-pressure-record/services/annulus-pressure-record.service';
import { ActivatedRoute, Router } from '@angular/router';
import module from "app/modules/annulus-pressure-record/annulus-pressure-record.module";

@Component({
  selector: 'app-apr-edit',
  templateUrl: './apr-edit.component.html',
  standalone: true,
  imports: module,
  styleUrls: ['./apr-edit.component.scss']
})
export class AprEditPage {
  public aprForm: FormGroup
  public initialFormValues: any;

  public aprRecord: any
  private aprId = this.route.snapshot.paramMap.get('id');

  ngOnInit() {
    this.aprForm = this.initializeForm()
    this.getApr()
  }

  constructor(
    private fb: FormBuilder,
    public location: Location,
    private aprService: AprService,
    private route: ActivatedRoute,
    private router: Router
  ) { }


  initializeForm() {
    return this.fb.group({
      aprId: '',
      wellStringId: '',
      wellStringName: [{ value: '', disabled: true }],
      activity: [{ value: '', disabled: true }],
      thp: 0,
      annAPress: 0,
      annBPress: 0,
      annCPress: 0,
      annDPress: 0,
      annATemp: 0,
      annBTemp: 0,
      annCTemp: 0,
      annDTemp: 0,
      remarks: '',
      recordDate: new Date().toISOString(),
      recordTime: formatTime(new Date)
    })
  }

  private getApr() {
    this.aprService.getAprRecord(this.aprId).subscribe((res) => {
      if (res) {
         this.aprRecord = res.data

        this.aprForm.patchValue({
          aprId: this.aprRecord.id,
          wellStringId: this.aprRecord.wellStringId,
          wellStringName: this.aprRecord.stringShortName,
          activity: this.aprRecord.activity,
          thp: this.aprRecord.thp,
          annAPress: this.aprRecord.annAPress,
          annBPress: this.aprRecord.annBPress,
          annCPress: this.aprRecord.annCPress,
          annDPress: this.aprRecord.annDPress,
          annATemp: this.aprRecord.annATemp,
          annBTemp: this.aprRecord.annBTemp,
          annCTemp: this.aprRecord.annCTemp,
          annDTemp: this.aprRecord.annDTemp,
          remarks: this.aprRecord.remarks,
          recordDate: this.aprRecord.recordDate,
          recordTime: this.getTime(this.aprRecord.recordDate)
        })

        this.initialFormValues = { ...this.aprForm.getRawValue() }
      }
    })
  }

  getTime(recordDate) {
    let date = new Date(recordDate)
    return formatTime(date)
  }

  editApr() {
    let recordDate = this.aprForm.get('recordDate').value

    if (typeof recordDate === 'object' && recordDate !== null) {
      let date = new Date()
      date.setDate(recordDate.get('day'))
      date.setMonth(recordDate.get('month') - 1)
      date.setFullYear(recordDate.get('year'))

      this.aprForm.patchValue({ recordDate: date.toISOString() })
    }

    const combinedDateTime = combineDateTime(this.aprForm.get('recordDate').value, this.aprForm.get('recordTime').value)
    this.aprForm.patchValue({ recordDate: combinedDateTime })

    this.aprService.updateAprecord(this.aprForm.get('aprId').value, this.aprForm.getRawValue())
      .subscribe((res) => {
        if (res) {
          this.back()
        }
      })
  }

  // Method to check if the form values have changed
  hasFormChanged(): boolean {
    return JSON.stringify(this.initialFormValues) !== JSON.stringify(this.aprForm.getRawValue());
  }

  handleDate(date) {
    return handleFormatDate(date, true)
  }

  back(){
    this.router.navigate(
      [`/data-management/annulus-pressure-record/`],
      { queryParams: { tab : this.aprRecord.activity } }
    );
  }

}
